let active_filters = [], current_index = null, state_push_count = 0;
let prevent_refresh = false;
const getUrlParams = () => {
   	 let search_params = new URLSearchParams(window.location.search);
      
     return Object.fromEntries(search_params.entries());
}

const matchPriceInputValue = (field_name, value) => { 
    let price_boxes = $(".price-range-group input");
    
    
    for (let i = 0; i < price_boxes.length; i++) {
      price_boxes.eq(i).attr('name') == field_name ? price_boxes.eq(i).val(value) : null;
    }
}

const setSliderValues = (value_array) => {
  	let price_slider = $(".price-range-slider");
    
    for (let i = 0; i < price_slider.length; i++) {
      price_slider.eq(i).slider("option", "values", value_array);
    }
}


const addPriceSliders = () => {
  let price_slider = $(".price-range-slider"), price_box = $(".price-range-list");

  console.log('Price sliders length:', price_slider.length);
  
  
  for (let i = 0; i < price_box.length; i++) {
   let min_value = parseFloat(price_box.eq(i).find(".range-min span").text()),
      	max_value = parseFloat(price_box.eq(i).find(".range-max span").text()),
       slider_init = parseFloat(max_value) / 2;
  
    
    price_slider.eq(i).slider({
      range: true,
      min: min_value,
      max: max_value,
      values: [min_value, slider_init],
      slide: function (event, ui) {

        for (let j = 0; j < price_box.length; j++) {
           price_box.eq(j).find("input").eq(0).val(ui.values[0]);
           price_box.eq(j).find("input").eq(1).val(ui.values[1]);
        }



        let range_values = [ui.values[0], ui.values[1]];


        setSliderValues(range_values);

      }
    })
  }
}


addPriceSliders();

let parameter_keys = [], parameter_values = [];


 const calculateActiveFilters = (index) => {
    
  	 let select_list = $(".filter-dropdown-list").eq(index);
   let checkbox = select_list.find("input"), active_checkbox_count = 0;
   
    
    for (let i = 0; i < checkbox.length; i++) {
      checkbox.eq(i).is(":checked") ? active_checkbox_count += 1 : null;
    }
   
   console.log('Active count:', active_checkbox_count)
    
    select_list.find(".active-selected").text(active_checkbox_count);
  }


const refreshState = (reset = false) => {
    let params = getUrlParams();
 
    
   if (Object.keys(params).length > 0) {
     parameter_keys = [], parameter_values = [];
    
    let query_parameters = decodeURIComponent(window.location.href).split("?")[1];
    let split_parameters = query_parameters.split("&");


  

    split_parameters.map(param => {
          let param_split = param.split("=");

          parameter_keys.push(param_split[0]);
          parameter_values.push(param_split[1]);
    })

    console.log({
      'Parameter keys': parameter_keys,
      'Parameter values': parameter_values
      
    })


          let form_fields = $('#regFilterForm input, #fullFilterForm select, #regFilterForm select');
     prevent_refresh = true;

      parameter_keys.map((key, index) => {
           for (let i = 0; i < form_fields.length; i++) {

             if (form_fields.eq(i).attr('name') === key) {
               if (form_fields.eq(i).attr('type') != 'checkbox') {
                  form_fields.eq(i).val(parameter_values[index]);
                 //console.log(form_fields.eq(i).attr('name'), form_fields.eq(i).val())

                 if (form_fields.eq(i).find("option").length > 0) {
                    let select_options = form_fields.eq(i).find("option");
                   for (let j = 0; j < select_options.length; j++) {
                     if (select_options.eq(j).attr('value') === parameter_values[index]) {
                        let selected_value = select_options.eq(j).text();

                       form_fields.eq(i).parent().find('.current-selected').text(selected_value);
                     }
                   }
                 } else {
                 	matchPriceInputValue(form_fields.eq(i).attr('name'), form_fields.eq(i).val())
                 }
               }
               else{

                 if (form_fields.eq(i).val() === parameter_values[index]) {
                   		

                      //form_fields.eq(i).parent().find('.icon-checkmark').show();

                      setTimeout(() => {
                         form_fields.eq(i).trigger('click'); 
                     }, 100)



                 }

               }



             }
        }
      })
      
      setTimeout(() => {
            $(".apply-button").eq(0).trigger('click');
            prevent_refresh = false;
     
     	$(".select-list").map(index => {
     		let first_input = $(".select-list").eq(index).find("input").eq(0);
          	first_input.data("full-filter-value", "1");
  			let click_count = new Array(2).fill('').map(item => {first_input.trigger('click')})
  			
  			setTimeout(() => {first_input.data("full-filter-value", "0")}, 200)
     	})
       }, 500)

    }
  }

const refreshValues = (form_fields) => {
  console.log('Parameter keys:', parameter_keys)
   if (parameter_keys.length > 0) {
      parameter_keys.map((key, index) => {
      	for (let i = 0; i < form_fields.length; i++) {
          if(form_fields.eq(i).attr('name') === key) {
            if (form_fields.eq(i).attr('type') == 'checkbox') {
            	if (form_fields.eq(i).val() === parameter_values[index]){
            		form_fields.eq(i).prop('checked', true)
            	}
            } else{
            	form_fields.eq(i).val(parameter_values[index])
            }
           
          }
      	}
      })
      
    }
}

const resetValues = () => {
  	let select_list = $(".select-list input");
    console.log('Reset value length:', select_list.length)
   
  
  	for (let i = 0; i < select_list.length; i++) {
  		let element = select_list.eq(i);
      	 
        let filter_index = parseInt(element.data('filter-index'))
        let parent = $(".filter-dropdown-list").eq(filter_index);
  		let index = parent.find("input").index(element);
      
      	parent.eq(index).find(".icon-checkmark").hide();
      
     	element.prop('checked', false);
  	}
  }


document.addEventListener("click", function (e) {
	 if (e.target.closest(".filter-dropdown-list li") == null && e.target.closest(".filter--dropdown") == null && e.target.closest(".full-filter-list input") == null) {
    	$(".filter-dropdown-list").hide();
    }

})

$(document).ready(function () {
  
  
  refreshState();
  
  if (window.history && window.history.pushState) {

    $(window).on('popstate', function () {
     // console.log('Parameters:', params);
      
      window.location.href = window.location.href;
      /*let params = getUrlParams();
      
      if (state_push_count > 0) {
        fetchFilterResults(window.location.href, true);
      }*/
    
      
  	})
  }
  

  
  $("#regFilterForm").on("submit",  function (e) {
  	e.preventDefault();
   //refreshState(true);
    
   
    
      
    let form_data = $(this).serialize();
    console.log('Reg filter form submitted:', form_data);
    
    let request_url = `${window.location.pathname}?${form_data}`;
    
    !prevent_refresh ? fetchFilterResults(request_url) : null;
    
    
  })
  
  $(".filter--dropdown").on("click", function (e) {
   let index = $(".filter--dropdown").index(this);
   // console.log('Matched target:', $(e.target).closest(".filter-dropdown-list").length )
    
    current_index != null && current_index != index ? $(".filter-dropdown-list").eq(current_index).hide() : null;
    
    if ($(e.target).closest(".filter-dropdown-list").length === 0) {
      	//$(".filter-dropdown-list").hide();
     	//console.log('Outside target, current index:', current_index)      	
    	$(this).find(".filter-dropdown-list").toggle();
        
        
    } 
    
    
    current_index = index;
  })
  
  $(".sort-list li").on("click", function () {
    
  	//console.log($(this).data('value'));
    let value = $(this).data('value');
    let filter_dropdown_list  = $(this).parent(), list_index = $(".sort-list").index(filter_dropdown_list);
    
    let filter_dropdown = $(".sort-options").eq(list_index);
    
    //console.log('Filter dropdown index:', filter_dropdown_list)
    
    filter_dropdown.find(".current-selected").text($(this).text());
    filter_dropdown.find("select").val(value);
    filter_dropdown_list.hide();
    
    $("#regFilterForm").trigger('submit');
  })
  
  
  
 
  
  $(".select-list input").on("change",  function () {
    	let current_state = $(this).prop('checked');
    	let form_fields = $("#regFilterForm input, #regFilterForm select");
    
    	refreshValues(form_fields);
    	$(this).prop('checked', current_state)
    	let filter_index = parseInt($(this).data('filter-index'))
        let parent = $(".filter-dropdown-list").eq(filter_index);
  		let index = parent.find("input").index(this);
    	let select_list = parent.find("li");
    
    	select_list.eq(index).find(".icon-checkmark").toggle();
    	let filter_value = select_list.eq(index).find(".filter-item-value").text();
    
    //console.log('Filter value:', filter_value)
    
    let filter_item = {
      label: filter_value,
      select_list_index: filter_index,
      select_item_index: index,
      type: "checkbox"
    }
  	
    calculateActiveFilters(filter_index);
      
    operateValue(filter_item);
          
          
   // console.log('New Active filters:', active_filters) 
    let checkboxes = $("#fullFilterForm input");
    let matching_filter_value = $(this).data('filter-value');
    
   matchFilters(checkboxes, matching_filter_value);
    
    console.log('Changed', parseInt($(this).data('full-filter-value')))
        
    parseInt($(this).data('full-filter-value')) == 0 ? $("#regFilterForm").trigger('submit') : null;
    	renderActiveFilters();
   
  })
  
 
  $(".price-range-group input").on("input",  function () {
    let field_value = $(this).val();
    
    
    let field_name = $(this).attr('name');
    
    
  	  if (field_value !== '') {
        let split_values = field_value.split("");
        split_values.filter((value, index) => {
          !validateInput(value) ? split_values.splice(index, 1) : null;

          if (value === ".") {
            split_values.slice(0, index).indexOf(value) !== -1 ? split_values.splice(index, 1) : null;
          }

        });
        
       
        let price_list_index = parseInt($(this).data('price-index')),
            price_range_list =$(".price-range-list").eq(price_list_index),
            range_list_index = price_range_list.find("input").index(this); 
        
       	      
        let split_value = split_values.join().replace(/,/g, "");
        let range_values = Array(2).fill('');
        let input_range = range_list_index === 0 ? range_values[0] = split_value : 
        				  range_values[1] = split_value;
        
        range_values.map((value, index) => {
          if (value === '') {
          	let price_index_value = price_range_list.find("input").eq(index).val();
            
            price_index_value != "" ? range_values[index] = price_index_value : null;
          }
        })

       	$(this).val(split_value);
       // console.log('Range values:', range_values)
        
        
        setSliderValues(range_values);
        matchPriceInputValue(field_name, split_value);

      }
  })
  

  

  
  $(".price-range-list .apply-button").on("click",  function (e) {
  	e.preventDefault();
    
   // console.log('Button clicked');
    let price_index = parseInt($(this).data('price-index'));
    
    let price_boxes = $(".price-range-box").eq(price_index).find("input");
    
    if (price_boxes.eq(0).val() != "" || price_boxes.eq(1).val() != "") {
      let filter_value = `${price_boxes.eq(0).val() != '' ? '$': ''}${price_boxes.eq(0).val()} - ${price_boxes.eq(1).val() != '' ? '$': ''}${price_boxes.eq(1).val()}`;
      //console.log('Element is visible:', $('.price-range-list').is(':visible'));
     
      let filter_item = {
        label: filter_value,
        type: "price"
      }
      active_filters.filter((item, index) => item.type === 'price' ? active_filters.splice(index, 1) : null);
      active_filters.push(filter_item);
      renderActiveFilters();
      
    if (price_index === 0) {
      	 $("#regFilterForm").trigger('submit');
      
          setTimeout(() => {
                 $('.price-range-list').is(':visible') ? $('.price-range-list').hide() : null;     
            }, 1000)
    } else{
    	$("#fullFilterForm").trigger('submit');
    }
      
      
    }
  })
  
  $('span.reset-button').on('click', function(){
    $("ul.filter-dropdown-list.select-list li span.check-box svg.icon-checkmark").hide();
  });
  
  $(".select-list .reset-button").on("click", function () {  
  	let index = $(".select-list .reset-button").index(this);
    console.warn('This is reset index - ', index)
    clearCheckBoxFilters(index);
    
    renderActiveFilters();
    $("#regFilterForm").trigger('submit');
  })
  
  $(".price-range-list .clear-button").on("click", function () {
  	
   	clearPriceFilters();
    
    $("#regFilterForm").trigger('submit');
  })
  
  /*document.addEventListener("click", function (e) {
    if (e.target) {
       console.log(e.target.classList)
    }
  })*/
  
  $("#activeFilterItems").on('click', '.active-filter-delete', function () {
    //console.log('Index:', $(this).parent().data('index'))
    let delete_index = parseInt($(this).parent().data('index'));
    
    let filter_item = active_filters[delete_index];
    if (filter_item.type == 'checkbox') {
    	let list_item = $(".filter-dropdown-list").eq(filter_item.select_list_index).find("li").eq(filter_item.select_item_index);
    
        list_item.find(".icon-checkmark").hide();
        list_item.find("input").prop('checked', false);
      
        let checkboxes = $("#fullFilterForm input");
        let matching_filter_value = list_item.find("input").data('filter-value');

        matchFilters(checkboxes, matching_filter_value);
    } else{
    	$(".price-range-list input").eq(0).val("");
      	$(".price-range-list input").eq(1).val("");
    }
    
    $("#regFilterForm").trigger('submit');
    
    active_filters.splice(delete_index, 1);
    renderActiveFilters();
    calculateActiveFilters(filter_item.select_list_index)
    
    
  })
  
  $(".full-reset-button").on('click', function () {
  		clearPriceFilters();
    	
    	let filter_options = $(".select-list");
    	
      for (let i = 0; i < filter_options.length; i++) {
			clearCheckBoxFilters(i);
      }
    
    	let full_filter_list = $(".full-filter-list");
    
    	full_filter_list.map((index, item) => {
    		let checkboxes = full_filter_list.eq(index).find("input");
          
          checkboxes.map((checkbox_index, checkbox_item) => {
          	let parent = checkboxes.eq(checkbox_index).parent();
            console.log('Icon-checkmark'+parent.find(".icon-checkmark"));
            parent.find(".icon-checkmark").hide();
            checkboxes.eq(checkbox_index).prop("checked", false);
          })
    	})
    
      	active_filters = [];
    	renderActiveFilters();
    
    $("#regFilterForm").trigger('submit');
  });
  
  /*------------ Collection sidebar ------------*/
  let sidebar = $("#fullCollectionFilters"), sidebar_content = $("#fullFilterContainer"), 
        sidebar_content_width = sidebar.width();
    
  
  $( ".view-all-filters, #fullFilterForm .icon-close").on("click", function (e) {
    e.preventDefault();
    
   // console.log('Item clicked');
    
    toggleFilterSidebar();
  })
  
  sidebar.on("click", function (e) {
    if ($(e.target).closest(".full-content-container").length === 0){
    	toggleFilterSidebar()
    }
  })
  
  $(".filter-item-heading").on("click", function () {
  	let index = $(".filter-item-heading").index(this);
    let header = $(this).parent();
    let menu_item = header.find(".menu-filter-item"), 
        full_height = $(this).outerHeight() + menu_item.outerHeight() + 15;
    
    let animate_height =  header.hasClass("dropdown-visible") ? $(this).outerHeight() : 
    						full_height;
    //console.log('Animated height:', animate_height)
    
    header.css('overflow', 'hidden');
    
    menu_item.toggle();
    
  
    header.animate({height: animate_height}, {
      duration: 300,
      complete: function () {
      	header.toggleClass('dropdown-visible');
        header.find(".caret-up").toggle();
        header.find(".caret-down").toggle();
    
        
        header.removeAttr('style');
        
      }
    })
  })
  
  
  
  
  const toggleFilterSidebar = () => {
      let sidebar = $("#fullCollectionFilters"), sidebar_content = $("#fullFilterContainer"), 
        sidebar_content_width = sidebar.width();
        $('body').toggleClass('scroll-none');
  	
   // console.log('Sidebar visible', sidebar.is(":visible"))
    sidebar.is(":visible") ? animateSidebar(`-${sidebar_content_width}`, true)
    : animateSidebar(0);
  }
  
  const animateSidebar = (distance, hide_sidebar = false) => {
      let sidebar = $("#fullCollectionFilters"), sidebar_content = $("#fullFilterContainer"), 
        sidebar_content_width = sidebar.width();
    
    if (!hide_sidebar) {
    	sidebar_content.css('marginLeft', `-${sidebar_content.width()}px`);	
      sidebar.show();
    }
   
    
    sidebar_content.animate({marginLeft: `${distance}px`}, {
        duration: 300,
        complete: function () {
          hide_sidebar ? sidebar.hide() : null;
          sidebar_content.removeAttr('style');
        }
      })
    
    let full_filter_items = $(".full-filter-item");
    
    for (let i = 0; i < full_filter_items.length; i++) {
    	full_filter_items.eq(i).removeClass("dropdown-visible");
      full_filter_items.eq(i).find(".menu-filter-item").hide();
      
      full_filter_items.eq(i).find(".caret-icon").removeAttr('style');
    }
  }
  
  $( "#fullFilterForm").on('submit', function (e) {
  	e.preventDefault();
    
    let formData = $(this).serialize();
    let request_url = `${window.location.pathname}?${formData}`;
    
    console.log('Full filter submitted', formData)
    
    !prevent_refresh ? fetchFilterResults(request_url) : null;
  })
  
  $(".full-filter-list input").on('change', function () {
    let current_state = $(this).prop('checked');
    let form_fields = $("#fullFilterForm input, #fullFilterForm select");
    
    refreshValues(form_fields);
    $(this).prop('checked', current_state);
    
    $(this).parent().find(".icon-checkmark").toggle();
    	console.log('Triggered');
    
    
  		
    if ($(this).attr('data-full-filter-value') == 0) {
    	$("#fullFilterForm").trigger('submit');
    
    
    	let filter_value = $(this).data('filter-value');
    	let checkboxes = $("#regFilterForm input");
    
    	matchFilters(checkboxes, filter_value);
    }
    
    	
  })
  
  $("#fullFilterApply").on("click", function () {
    $("#fullFilterForm").find(".apply-button").trigger('click');
  	$("#fullFilterForm").trigger('submit');
    toggleFilterSidebar();
  })

  const matchFilters = (selector, filter_value) => {
	let input_index;
    
      for(let i = 0; i < selector.length; i++) {
        if (selector.eq(i).data('filter-value') == filter_value) {
        	input_index = i;
          	selector.eq(i).attr('data-full-filter-value', '1');
          	selector.eq(i).trigger('click')
        }
      }
    
    
    setTimeout(() => {
        selector.eq(input_index).attr('data-full-filter-value', '0');        
     }, 10)
  }

  
     
   const fetchFilterResults = (request_url, popstate = false) => {
  console.log('Request URL:', request_url)
     $(".all-products--count").find(".process-spinner").remove();
     $(".all-products--count").append(`<div class="process-spinner"></div>`);
     $("#ProductGridContainer .collection").append('<div class="loading--overlay"></div>')
     
    $.get(request_url, function (response) {
        let response_body = new DOMParser().parseFromString(response, 'text/html');
        console.log('Request response:', response_body);
		
     let filter_results = response_body.querySelector(".all-product-value").innerText;
         window.history.pushState({}, '', request_url);
      
      		$(".all-products--count").find(".process-spinner").remove();

          $("#ProductGridContainer").html(response_body.getElementById("ProductGridContainer").innerHTML);
      	
      		let result_length = $("#product-grid li").length;
      		//console.log('Result length:', result_length);
      
      		$("#filterProductValue").remove();
      
     // console.log('Filter results:', filter_results)
      		
          
				$(".all-product-value").text(filter_results)
                
                if (popstate) {
                	$("#main-collection-filters").html(response_body.getElementById("main-collection-filters").innerHTML)
                    active_filters = [];
                    addPriceSliders();
                  
                  	refreshState();
                }
              
      
      popstate ? state_push_count -= 1 : state_push_count += 1;
      
      })
  }
   
   const clearCheckBoxFilters = (index) => {
    let select_list = $(".select-list").eq(index);
     console.log('this is select list - '+ select_list)
   	let checkboxes = select_list.find("input"), list_items = select_list.find(".filter-item-value");
    

    select_list.find(".active-selected").text(0);
    
    console.log("Checkboxes:", checkboxes);
    
    for (let i = 0; i < checkboxes.length; i++) {
      	
    	checkboxes.eq(i).prop("checked", false);
      	let filter_value = list_items.eq(i).text();
      	active_filters.filter((item, index) => item.label === filter_value ? active_filters.splice(index, 1) : null);
        console.log("i value -"+ i)
      	$(".select-list li").eq(i).find(".icon-checkmark").hide();
    }
   
   }
   
   const clearPriceFilters = () => {
   	let price_box = $(".price-range-list").find("input");
    
    price_box.eq(0).val("");
    price_box.eq(1).val("");
     
    active_filters.filter((item, index) => item.type === 'price' ? active_filters.splice(index, 1) : null);
    renderActiveFilters();
   }
   
  
  const operateValue = (filter_item) => {
  	let matching_indexes = [];

    let matching_filters = active_filters.filter((item, index) => item.label === filter_item.label ? matching_indexes.push(index) : null);
           
    matching_filters.length === 0 ? active_filters.push(filter_item) : 
    matching_indexes.map(item => active_filters.splice(item, 1));
  }
  
  const renderActiveFilters = () => {
    $("#activeFilterItems").html("");
    
    active_filters.map((item, index) => {
    	$("#activeFilterItems").append(`
			<div class="filter-button alternate" data-index="${index}">
				<svg class="active-filter-delete" xmlns="http://www.w3.org/2000/svg" width="8.486" height="8.486" viewBox="0 0 8.486 8.486">
                  <path id="Ic-Close" d="M-7536.464-431.464l-3.536,3.536,3.536-3.536L-7540-435l3.536,3.536,3.536-3.536-3.536,3.536,3.536,3.536Z" transform="translate(7540.707 435.707)" fill="none" stroke="#454d50" stroke-width="2"/>
                </svg>

				<span class="active-filter-value">${item.label}</span>
			</div>

			
		`)
    })
  }
  

});


const validateInput = (input) => {
      let supported_characters = Array(10).fill("");
  		
  supported_characters.map((value, index) => {
  	supported_characters[index] = index.toString();
  })
  
  supported_characters.push(".");

  return supported_characters.indexOf(input) !== -1;
}